import { TaglineLink } from '@components/taglineLink';
import { useFragment } from 'react-relay';
import { linkGroupFragment } from './LinkGroup.relay';
import { LinkGroupHeading } from './lib/LinkGroupHeading';
import type { LinkGroupPropsType } from './types';

const LinkGroup: React.FC<LinkGroupPropsType> = (props: LinkGroupPropsType) => {
  const frontGroup = useFragment(linkGroupFragment, props.frontGroup);

  return (
    <div>
      <LinkGroupHeading>{frontGroup.title}</LinkGroupHeading>
      {frontGroup.links.map((link, index) => (
        // biome-ignore lint/suspicious/noArrayIndexKey: static is fine here
        <TaglineLink key={index} tagLineLink={link} />
      ))}
    </div>
  );
};

export { LinkGroup };
